module.exports.ASSESSMENT_SOURCE = {
  KIOSK: 'kiosk',
  MANUAL_EMAIL: 'manual_email',
  MANUAL_SMS: 'manual_sms'
}